export const LOCALES = {
    ENGLISH: "en-us",
    SPANISH: "es-co",
  };